import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#000014",
        secondary: '#ff0000',
        accent: '#ff0000',
        error: '#D88C9A',
        info: '#ADD9F4',
        success: '#B3DEC1',
        warning: '#C2C7CA',
      },
      dark: {
        primary: "#000014",
        secondary: '#ff0000',
        accent: '#ff0000',
        error: '#D88C9A',
        info: '#ADD9F4',
        success: '#B3DEC1',
        warning: '#C2C7CA',
        anchor: '#ffffff'
      }
    }
  }
});
